var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAward = function SvgAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 30,
    fill: "none",
    viewBox: "0 0 22 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m5.492 19.613-1.159 8.72 6.118-3.67c.2-.12.3-.18.406-.203a.7.7 0 0 1 .286 0c.106.023.206.083.406.203l6.118 3.67-1.158-8.723m.392-14.945c.206.498.601.894 1.1 1.1l1.744.724a2.033 2.033 0 0 1 1.1 2.655l-.722 1.745a2.03 2.03 0 0 0 0 1.556l.722 1.743a2.033 2.033 0 0 1-1.1 2.657L18 17.568a2.03 2.03 0 0 0-1.1 1.098l-.723 1.746a2.03 2.03 0 0 1-2.656 1.1l-1.744-.723a2.03 2.03 0 0 0-1.555.002l-1.745.721a2.03 2.03 0 0 1-2.654-1.099L5.1 18.667a2.03 2.03 0 0 0-1.1-1.1l-1.744-.723a2.033 2.033 0 0 1-1.1-2.655l.721-1.744a2.03 2.03 0 0 0 0-1.555l-.722-1.747a2.033 2.033 0 0 1 1.1-2.656L4 5.764c.498-.205.893-.6 1.1-1.097l.723-1.746a2.033 2.033 0 0 1 2.656-1.1l1.744.723a2.03 2.03 0 0 0 1.555-.001l1.746-.72a2.033 2.033 0 0 1 2.655 1.1l.723 1.745z"
  })));
};
export default SvgAward;